import React, { useEffect, useState } from "react";
import * as PropTypes from "prop-types";
import { useTranslation } from "next-i18next";

import Tile from "../Tile/Tile";

import { getImageByClass } from "../../../assets/CategoryIcons";
import { isDarkTheme } from "@/shared/utils/theme/theme";
import { useTheme } from "@/hooks/useTheme";

import styles from "./tile-list.module.scss";

const TileList = ({ items }) => {
  const { t } = useTranslation();
  const { activeTheme } = useTheme();

  const [darkTheme, setDarkTheme] = useState(false);

  // Fixes hydration error: Prop `className` did not match.
  useEffect(() => {
    setDarkTheme(isDarkTheme(activeTheme));
  }, [activeTheme]);

  return (
    <div className={styles["tile-list"]}>
      {items.map(({ key, title, imageUrl, count, className, id, ...restProps }) => {
        return <Tile
          key={key}
          count={count ? `${count} ${t("books")}` : undefined}
          title={t(title)}          
          image={getImageByClass(className, darkTheme, id)}
          imageUrl={imageUrl}
          {...restProps}
        />;
      })}
    </div>
  );
};

TileList.propTypes = {
  items: PropTypes.array,
};

export default TileList;
